// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WE1n","right":"styles_right__3kvdA"};